import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import _ from "lodash";
import { commonContainerWidth } from "Constants";

// Import Files
import GamificationMenu from "./gamification-menu";
import GamificationChallenges from "GamificationChallenges"; //Manage Challenges
import GamificationLeaderboard from "GamificationLeaderboard"; //Leaderboard
import GamificationRewards from "GamificationRewards"; //Rewards Settings

class Gamifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserAuthenticated: true,
    };
  }

  componentDidMount() {
    if (this.props.history.location.pathname == "/dashboard/gamification") {
      //this.props.history.location.pathname = '/dashboard/gamification/challenge';
      this.props.history.push(`/dashboard/gamification/challenge`);
    }
  }

  // Menu List Of Gamification
  renderOptionList() {
    let { gamificationMenus } = this.props;

    // Return Generated menu from from array
    return gamificationMenus.map((item, index) => {
      if (item) {
        return (
          <GamificationMenu
            history={this.props.history}
            key={item.iconName}
            item={item}
          />
        );
      }
    });
  }

  render() {
    return (
      <div>
        <div className="content-parent-container">
          <div className="content-submenu vertical-line">
            <div>
              <ul className="list-group">{this.renderOptionList()}</ul>
            </div>
          </div>
          <div
            className="content-subcontainer"
            // style={{ width: `${commonContainerWidth}px` }}
          >
            <Route
              path="/dashboard/gamification/challenge"
              component={GamificationChallenges}
              history={this.props.history}
            />
            <Route
              path="/dashboard/gamification/leaderboard"
              component={GamificationLeaderboard}
              history={this.props.history}
            />

            <Route
              path="/dashboard/gamification/reward"
              component={GamificationRewards}
              history={this.props.history}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    gamificationMenus: state.gamificationMenus,
  };
}

export default connect(mapStateToProps, {})(Gamifications);
